<template>
    <div class="container">
        <h2>??Map Parameters Editor</h2>
        <label>Sort method:</label>
        <select v-model="sortMethod">
            <option disabled value="">??Please select one</option>
            <option value="no_sort">??No Sort</option>
            <option value="alphabetically">??Alphabetically</option>
            <option value="distance">??Distance from user</option>
        </select>

        <input type="checkbox" id="showCalculatedDistance" value="true" v-model="showCalculatedDistance">
        <label for="showCalculatedDistance">??Show calculated distance</label>
        
        <input type="checkbox" id="openMapObjectListByDefault" value="true" v-model="openMapObjectListByDefault">
        <label for="openMapObjectListByDefault">??Open Map Object List by default</label>

        <button class="btn btn-primary" v-on:click="onSaveClicked()">??Save</button>
        <button class="btn btn-light" v-on:click="onCancelClicked()">??Cancel</button>
    </div>    
</template>

<script>
import MapService from '@/service/MapService';

export default {
    name: "MapParametersEditor",
    props: {
        publisherId: null,
        mapId: null,
    },
    data() {
        return {
            map: null,
            mapService: new MapService()
        }
    },
    computed: {
        sortMethod: {
            get: function() {
                return this.map != null ? this.map.sortMethod : "no_sort";
            },
            set: function(newValue) {
                if (this.map != null) {
                    this.map.sortMethod = newValue;
                }
            }
        },
        showCalculatedDistance: {
            get: function() {
                return this.map != null ? this.map.showCalculatedDistance : true
            },
            set: function(newValue) {
                if (this.map != null) {
                    this.map.showCalculatedDistance = newValue == true;
                }
            }
        },
        openMapObjectListByDefault: {
            get: function() {
                return this.map != null ? this.map.openMapObjectListByDefault : false;
            },
            set: function(newValue) {
                if (this.map != null) {
                    this.map.openMapObjectListByDefault = newValue == true;
                }
            }
        }
    },
    methods: {
        loadMap() {
            if (this.publisherId && this.mapId) {
                this.mapService.loadMapForPublisher(this.publisherId, this.mapId).then((map) => {
                    this.map = map;
                }).catch((error) => {
                    // TODO
                    console.log(error);
                });
            }
        },

        onSaveClicked() {
            console.log(this.publisherId);
            console.log(this.map);
            this.mapService.saveMapForPublisher(this.publisherId, this.map).then(() => {
                this.$emit("mapParametersSaved");
            }).catch((error) => {
                // TODO
                console.log(error);
            })
        },

        onCancelClicked() {
            this.$emit("mapParametersEditionCancelled");
        }
    },
    mounted() {
        this.loadMap();
    }
}
</script>

<style scoped>
.container {
    padding: 20px;
    text-align: left;
}
</style>